import { appNames } from "../utils/functions/app";
import useAppVariant from "./useAppVariant";

export default function useAppName() {
  const appVariant = useAppVariant();

  return appNames[appVariant];
}
